import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

import { ExtendedWorkspaceListItem } from '@futrli/views/operations/workspaces/processors/workspacesList';

interface WorkspaceFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
  workspaces?: ExtendedWorkspaceListItem[];
}

export const WorkspaceFilter = ({ onChange, selectedValue, workspaces = [] }: WorkspaceFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const options = useMemo(
    () => [
      {
        value: 'all',
        label: intl.formatMessage({ id: 'predict.filters.workspace.all', defaultMessage: 'All workspaces' })
      },
      ...workspaces.map(workspace => ({
        value: workspace.id,
        label:
          workspace.name ||
          intl.formatMessage(
            { id: 'landing.default_workspace_name', defaultMessage: "{name}'s workspace" },
            { name: workspace?.owner.first_name }
          )
      }))
    ],
    [workspaces, intl]
  );

  return (
    <Box width={250}>
      <SimpleSelect
        label={intl.formatMessage({
          id: 'predict.filters.workspace.label',
          defaultMessage: 'Workspace'
        })}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map(option => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </SimpleSelect>
    </Box>
  );
};
